import { faCube, faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { AppGrid } from '~/components/organisms/AppGrid';

export type IAppsPageProps = Record<string, never>;

export const AppsPage: React.FC<IAppsPageProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppsPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faCube} />}
        title={t('AppsPage.title')}
        subtitle={t('AppsPage.subtitle')}
        actions={
          <Button href="/apps/create" icon={<FontAwesomeIcon icon={faPlus} />}>
            {t('AppsPage.create')}
          </Button>
        }
      />

      <AppGrid />
    </>
  );
};
